import { useState } from 'react';
import { Navbar, Nav, Container, Button, Dropdown, Offcanvas } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Header = () => {
  const { currentUser, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  const handleLogout = async () => {
    try {
      await logout();
      handleClose();
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const navContent = (
    <Nav className="ms-auto align-items-lg-center">
      <Nav.Link as={Link} to="/" onClick={handleClose}>
        Home
      </Nav.Link>

      {isAuthenticated ? (
        <>
          <Nav.Link as={Link} to="/search/results" onClick={handleClose}>
            Search
          </Nav.Link>

          <Nav.Link as={Link} to="/messages" onClick={handleClose}>
            Messages
          </Nav.Link>

          <Dropdown align="end">
            <Dropdown.Toggle variant="outline-dark" id="dropdown-basic" className="d-flex align-items-center">
              {currentUser.avatars && currentUser.avatars.small ? (
                <img
                  src={currentUser.avatars.small}
                  alt={currentUser.username}
                  className="avatar-small me-2"
                />
              ) : (
                <i className="bi bi-person-circle me-2"></i>
              )}
              {currentUser.username}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item as={Link} to="/profile" onClick={handleClose}>
                My Profile
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/photos" onClick={handleClose}>
                My Photos
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/credits" onClick={handleClose}>
                Credits
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={handleLogout}>
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </>
      ) : (
        <>
          <Nav.Link as={Link} to="/login" onClick={handleClose}>
            Login
          </Nav.Link>
          <Button
            as={Link}
            to="/register"
            variant="primary"
            className="ms-lg-3 mt-3 mt-lg-0"
            onClick={handleClose}
          >
            Sign Up
          </Button>
        </>
      )}
    </Nav>
  );

  return (
    <Navbar
      bg="light"
      variant="light"
      expand="lg"
      className="shadow-sm py-3"
      sticky="top"
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="fw-bold text-dark d-flex align-items-center">
          <img
            src="/logo.svg"
            alt="Paperdate Logo"
            height="30"
            className="me-2"
          />
          Paperdate
        </Navbar.Brand>

        {/* Desktop navigation - visible on lg and up */}
        <Navbar.Collapse id="basic-navbar-nav" className="d-none d-lg-flex">
          {navContent}
        </Navbar.Collapse>

        {/* Mobile menu toggle - visible below lg */}
        <Navbar.Toggle
          aria-controls="offcanvas-navbar"
          className="d-lg-none"
          onClick={handleShow}
        />

        {/* Mobile offcanvas menu - slides from right */}
        <Offcanvas
          show={showOffcanvas}
          onHide={handleClose}
          placement="end"
          className="d-lg-none"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title className="fw-bold d-flex align-items-center">
              <img
                src="/logo.svg"
                alt="Paperdate Logo"
                height="24"
                className="me-2"
              />
              Paperdate
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {navContent}
          </Offcanvas.Body>
        </Offcanvas>
      </Container>
    </Navbar>
  );
};

export default Header;
